export default __webpack_public_path__ + "static/media/indoor_green.9ff46514.mp4";